import { Container } from 'inversify'

import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindIncidentsResultConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.IncidentsResultConfiguration)
    .toDynamicValue(() => {
      return {
        scoringIncidents: new Map([
          [BasketballIncidentId.FreeThrowIn, { add: 1, visible: true }],
          [BasketballIncidentId.TwoPointShotMade, { add: 2, visible: true }],
          [BasketballIncidentId.ThreePointShotMade, { add: 3, visible: true }],
          [BasketballIncidentId.FourPointShotMade, { add: 4, visible: true }],
        ]),
      }
    })
    .inSingletonScope()
}
